import ClientsDB from 'src/fb/clients-db';
import ProgramsDB from 'src/fb/programs-db';
import SessionsDB from 'src/fb/sessions-db';

/**
 * @param {string} sessionId
 * @returns {Promise<Object|null>}
 */
export async function readSession(sessionId) {
  const sessionsDb = new SessionsDB();
  return sessionsDb.read(sessionId);
}

/**
 * @param {Object} session
 * @returns {Promise<{ allPrograms: Object[], client: Object }>}
 */
export async function readSessionRelations(session) {
  const [allPrograms, client] = await Promise.all([
    new ProgramsDB().readAll([['client', '==', session.client]]),
    new ClientsDB().read(session.client),
  ]);
  return { allPrograms, client };
}
